module.exports = __webpack_public_path__ + "img/page_image_1_1.d7f1e02e.svg";